// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"1187e576","535":"e210b485","537":"2dacf3e4","950":"8da987df"}[chunkId] + ".chunk.js";
};